if (!customElements.get('faq-media-banner')) {
  customElements.define(
    'faq-media-banner',
    class FaqMediaBanner extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.activeKey = this.dataset.initialKey;
        this.desktopItems = [...this.querySelectorAll('[data-faq-desktop-item]')];
        this.mobileTriggers = [...this.querySelectorAll('[data-faq-mobile-trigger]')];
        this.mobilePanels = [...this.querySelectorAll('[data-faq-mobile-panel]')];
        this.media = [...this.querySelectorAll('[data-faq-media]')];
        this.mobilePreview = this.querySelector('[data-faq-mobile-preview]');
        this.mobileFallback = this.querySelector('[data-faq-mobile-fallback]');
        this.mobileDialog = this.querySelector('[data-faq-mobile-dialog]');
        this.previousButton = this.querySelector('[data-faq-previous]');
        this.nextButton = this.querySelector('[data-faq-next]');
        this.closeButtons = [...this.querySelectorAll('[data-faq-close]')];
        this.desktopMediaQuery = window.matchMedia('(min-width: 990px)');

        this.desktopItems.forEach((item) => {
          item.addEventListener('toggle', () => this.onDesktopToggle(item));
        });

        this.mobileTriggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.openMobile(trigger.dataset.faqKey, trigger));
        });

        this.previousButton?.addEventListener('click', () => this.moveMobile(-1));
        this.nextButton?.addEventListener('click', () => this.moveMobile(1));
        this.closeButtons.forEach((button) => button.addEventListener('click', () => this.closeMobile()));
        this.addEventListener('keydown', (event) => this.onKeydown(event));
        this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event));
        this.onViewportChange = () => {
          const mobileDialogOpen = this.mobileDialog && !this.mobileDialog.hidden;
          this.setActive(this.activeKey, { playMobile: mobileDialogOpen });
        };
        this.desktopMediaQuery.addEventListener('change', this.onViewportChange);

        if (this.mobileFallback) this.mobileFallback.hidden = true;
        if (this.mobilePreview) this.mobilePreview.hidden = false;
        this.setActive(this.activeKey, { playMobile: false });
      }

      onDesktopToggle(item) {
        if (!item.open) return;

        this.desktopItems.forEach((otherItem) => {
          if (otherItem !== item) otherItem.open = false;
        });
        this.setActive(item.dataset.faqKey, { playMobile: false });
      }

      setActive(key, options = {}) {
        if (!key) return;
        this.activeKey = key;

        this.media.forEach((media) => {
          const active = media.dataset.faqKey === key;
          media.classList.toggle('is-active', active);
          media.setAttribute('aria-hidden', String(!active));

          media.querySelectorAll('video').forEach((video) => {
            const isMobileMedia = media.dataset.faqViewport === 'mobile';
            const desktopViewport = this.desktopMediaQuery.matches;
            const shouldPlay =
              active &&
              ((desktopViewport && !isMobileMedia) ||
                (!desktopViewport && isMobileMedia && options.playMobile !== false));
            if (shouldPlay) {
              video.play().catch(() => {});
            } else {
              video.pause();
            }
          });
        });

        this.mobileTriggers.forEach((trigger) => {
          trigger.setAttribute('aria-pressed', String(trigger.dataset.faqKey === key));
        });

        this.mobilePanels.forEach((panel) => {
          panel.hidden = panel.dataset.faqKey !== key;
        });

        const index = this.mobileTriggers.findIndex((trigger) => trigger.dataset.faqKey === key);
        if (this.previousButton) this.previousButton.disabled = index <= 0;
        if (this.nextButton) this.nextButton.disabled = index < 0 || index >= this.mobileTriggers.length - 1;
      }

      openMobile(key, trigger) {
        this.returnFocus = trigger;
        this.setActive(key);
        if (this.mobilePreview) this.mobilePreview.hidden = true;
        if (this.mobileDialog) this.mobileDialog.hidden = false;

        requestAnimationFrame(() => {
          this.mobileDialog?.querySelector('[data-faq-close]:not([hidden])')?.focus();
        });
      }

      closeMobile() {
        if (this.mobileDialog) this.mobileDialog.hidden = true;
        if (this.mobilePreview) this.mobilePreview.hidden = false;
        this.pauseMobileVideos();
        this.returnFocus?.focus();
      }

      moveMobile(direction) {
        const currentIndex = this.mobileTriggers.findIndex((trigger) => trigger.dataset.faqKey === this.activeKey);
        const nextIndex = currentIndex + direction;
        if (nextIndex < 0 || nextIndex >= this.mobileTriggers.length) return;
        this.setActive(this.mobileTriggers[nextIndex].dataset.faqKey);
      }

      pauseMobileVideos() {
        this.querySelectorAll('[data-faq-viewport="mobile"] video').forEach((video) => video.pause());
      }

      onKeydown(event) {
        if (!this.mobileDialog || this.mobileDialog.hidden) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeMobile();
          return;
        }

      }

      onBlockSelect(event) {
        const item = event.target.closest('[data-faq-desktop-item]');
        if (!item) return;
        item.open = true;
        this.setActive(item.dataset.faqKey, { playMobile: false });
      }

      disconnectedCallback() {
        this.desktopMediaQuery?.removeEventListener('change', this.onViewportChange);
      }
    }
  );
}
